<template>
  <div class="position-relative">
    <b-container fluid class="ps-0">
      <b-row>
        <b-col lg="3" xl="2" xxl="2" class="staticleftsidebar">
          <LeftBar masterheading="Supplier Master" pagename="SupplierMasterDetailsView" v-model="datas"
            :storestatus="false" :listed="sidebardata"></LeftBar>
          <a class="back-btn" @click="$router.push({ path: '/SupplierMasterTableview' })">
            <img alt="Vue logo" class="back" src="../../../../../../assets/Img/icons/backtoright.svg" width="125"
              height="125" />
          </a>
        </b-col>
        <b-col lg="9" xl="10" xxl="10">
          <b-container fluid>
            <b-row>
              <b-col class="my-5">
                <p class="light-txt">{{ datas.Code }}</p>
                <p class="common-heading1">{{ datas.Name }}</p>
                <!-- <Headerlayout :headertext="datas.Name"></Headerlayout> -->
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <TabView class="tabview-custom transaction-tabs" :scrollable="true">
                  <TabPanel>
                    <template #header>
                      <i class="pi pi-align-left pe-1"></i>
                      <span>Details</span>
                    </template>
                    <div>
                      <SupplierDetails />
                    </div>
                  </TabPanel>
                  <TabPanel>
                    <template #header>
                      <i class="pi pi-shopping-bag pe-1"></i>
                      <span>Items</span>
                    </template>
                    <div>
                      <DetailsTableview :propsParams="paramValues" />
                    </div>
                  </TabPanel>

                  <TabPanel>
                    <template #header>
                      <i class="pi pi-users pe-1"></i>
                      <span>PO</span>
                    </template>
                    <div>
                      <POTableview :propsParams="paramValues" />
                    </div>
                  </TabPanel>
                  <TabPanel>
                    <template #header>
                      <i class="pi pi-users pe-1"></i>
                      <span>PO Ammendment</span>
                    </template>
                    <div>
                      <POAmmendmentTableview :propsParams="paramValues" />
                    </div>
                  </TabPanel>
                  <TabPanel>
                    <template #header>
                      <i class="pi pi-users pe-1"></i>
                      <span>GRN</span>
                    </template>
                    <div>
                      <GrnTable :propsParams="paramValues" />
                      <!-- <TabView class="tabview-custom my-3" ref="tabview4" :scrollable="true">
                                            <TabPanel>
                                                <template #header>
                                                    <span>GRN</span>
                                                </template>
                                                <div>
                                                    <GrnTable :propsParams.Id="Id" />
                                                </div>
                                            </TabPanel>
                                            <TabPanel>
                                                <template #header>
                                                    <span>Returns</span>
                                                </template>
                                                <div>
                                                    <GrnReturnTableview :propsParams.Id="Id" />
                                                </div>
                                            </TabPanel>
                                        </TabView> -->
                    </div>
                  </TabPanel>
                  <TabPanel>
                    <template #header>
                      <i class="pi pi-users pe-1"></i>
                      <span>Documents</span>
                    </template>
                    <div>
                      <ItemDetailsDocumentsTableView />
                    </div>
                  </TabPanel>

                  <TabPanel>
                    <template #header>
                      <i class="pi pi-save pe-1"></i>
                      <span>Item Category</span>
                    </template>
                    <div>
                      <ItemSupplierMappingTblview :tstatus="true" :propsParams="paramValues" />
                    </div>
                  </TabPanel>
                  <TabPanel>
                    <template #header>
                      <i class="pi pi-users pe-1"></i>
                      <span>Activity Logs</span>
                    </template>
                    <div>
                      <Log />
                    </div>
                  </TabPanel>
                </TabView>
              </b-col>
            </b-row>
          </b-container>
        </b-col>
      </b-row>
    </b-container>
    <div class="center" v-if="loading">
      <Loader :loading="loading" />
    </div>
  </div>
</template>

<script lang="ts">
import Headerlayout from "../../../../../../components/Masters/HeaderLayout.vue";
import { defineComponent, ref, computed, onMounted, watch } from "vue";
import LeftBar from "../../../../../../modules/Inventory/components/MasterDetails/LeftSideBar.vue";
import Details from "../../../../../../modules/Inventory/components/MasterDetails/Details.vue";
import MemberDetails from "../../../../../../modules/Inventory/components/MasterDetails/MemberDetails.vue";
import Log from "../../../../../../modules/Inventory/components/MasterDetails/TabsPage/Log.vue";
import { useRoute } from "vue-router";
import POTableview from "../../../../../../modules/Inventory/pages/Transaction/PurchaseOrder/POTable.vue";
import RequestTable from "../../../../../../modules/Inventory/pages/Transaction/stockwithoutaffect/Request/RequestTable.vue";
import PITable from "../../../../../../modules/Inventory/pages/Transaction/PurchaseIndent/PurchaseIndentTable.vue";
import IssueTable from "../../../../../../modules/Inventory/pages/Transaction/StockOut/issuereturn/ItemIssueTable.vue";
import GrnTable from "../../../../../../modules/Inventory/pages/Transaction/stockin/grn/GrnTable.vue";
import PurchaseIndentTableVue from "../../../../../../modules/Inventory/pages/Transaction/PurchaseIndent/PurchaseIndentTable.vue";
import POAmmendmentTableview from "../../../../../../modules/Inventory/pages/Transaction/POAmmendment/POAmmendmentTableview.vue";
// import DetailsTableview from "../../../../../../modules/Inventory/pages/Masters/Items/ItemMaster/DetailsTableview.vue";
import DetailsTableview from "../../../../../../modules/Inventory/components/MasterDetails/TabsPage/SupplierDetailsItemsTabView.vue";
import QuotesTableview from "../../../../../../modules/Inventory/pages/Transaction/stockwithoutaffect/quotes/QuotesTableview.vue";
import storetab from "../../../../../../modules/Inventory/pages/Masters/Stores/StoreMaster/StoreTab/mainstore.vue";
import ItemSupplierMappingTblview from "../../../../../../modules/Inventory/pages/Masters/ItemCategory/ItemSupplierMapping/ItemSupplierMappingTblview.vue";
import supplierservice from "../../../../Service/SupplierMaster";
import SupplierDetails from "../../../../../../modules/Inventory/components/MasterDetails/TabsPage/SupplierDetails.vue";
import GrnReturnTableview from "../../../../../../modules/Inventory/pages/Transaction/StockOut/grnreturn/GrnReturnTableview.vue";
import ItemDetailsDocumentsTableView from "../../../../../../modules/Inventory/components/MasterDetails/TabsPage/ItemDetailsDocumentsTableView.vue";
import Loader from "../../../../../../components/FormComponents/Loader.vue";

export default defineComponent({
  components: {
    GrnReturnTableview,
    SupplierDetails,
    ItemSupplierMappingTblview,
    QuotesTableview,
    DetailsTableview,
    POAmmendmentTableview,
    POTableview,
    LeftBar,
    Details,
    MemberDetails,
    Log,
    Headerlayout,
    PurchaseIndentTableVue,
    RequestTable,
    PITable,
    IssueTable,
    GrnTable,
    storetab,
    ItemDetailsDocumentsTableView,
    Loader,
  },
  props: {
    showDetailsTab: {
      readonly: false,
      type: Boolean,
      default: false,
    },
    showItemsTab: {
      readonly: false,
      type: Boolean,
      default: false,
    },
  },
  setup() {
    let datas = ref({
      Id: ref(),
      Name: "",
      Code: "",
    });
    const loading = ref(false);

    const route = useRoute();

    const paramValues = ref({
      Id: "",
      Type: "",
    });

    let session: any = localStorage.getItem('UsersData')

    session = JSON.parse(session)
    let HospitalId = Number(session.OrganizationId);
    let BranchId = Number(session.BranchId);
    watch(
      () => route.query.Id,
      (newVal: any) => {
        debugger;
        paramValues.value.Id = newVal;
        paramValues.value.Type = route.query.Type as string;
      }
    );
    onMounted(() => {
      paramValues.value.Id = String(route.query.Id);
      paramValues.value.Type = route.query.Type as string;
      IsShow();
    });

    const paramValue = computed(() => {
      return route.query.param as string;
    });
    const sidebardata = ref([]);
    async function IsShow() {
      debugger;
      loading.value = true;

      try {
        const response = await supplierservice.gettable();
        console.log(response["result"]);
        sidebardata.value = response["result"].filter((items) => items.HospitalId == HospitalId && items.BranchId == BranchId);
        let obj = sidebardata.value.filter(
          (items) => items["Id"] == paramValues.value.Id
        );

        datas.value.Name = obj[0]["Name"];
        datas.value.Code = obj[0]["Code"];
        datas.value.Id = obj[0]["Id"];
        loading.value = false;
      } catch (error) {
        loading.value = false;

        console.log(error);
      }
    }
    return {
      sidebardata,
      paramValue,
      datas,
      paramValues,
      loading,
    };
  },
});
</script>

<style lang="scss">
.p-tabview-header span {
  white-space: nowrap;
}

.tabview-custom {
  width: 99%;
}

.staticleftsidebar {
  position: sticky !important;
  top: 0;
}
</style>
